import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import api from "../../../API";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import TzaWikiListPage from "./TzaWikiListPage"

const TzaWorkerWikiPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'TZA_ISP').map((info:any) => info.user_id)[0];   
  
  const [work_yn, setWork_yn] = useState("모두");

  const [workList, setWorkList] = useState([]);

  const [page, setPage] = useState(1);
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const swWikiWorkList = async (work_yn:string) => {
    
    setBackdrop(true)
    api.get('/sw-wiki-workList',{params:{email:email,page:page,worker:worker,work_yn:work_yn}})
    .then((res:any) => {
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        setWorkList(res.data);
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        setWorkList(res.data);
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }


  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  useEffect(() => {
    // getAuth()
    swWikiWorkList(work_yn)
  },[page])

  return (
    <Box>
      {backdrop && ( <SearchBackDrop/> )}
      {/* 상단 메뉴 */}
      <Box display="flex" sx={{padding:"4px 8px 8px 8px"}}>
        <Box display="flex">
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px",alignSelf: "center"}}>작업할당 목록 (<b style={{color:"#1976d2"}}>{total_cnt != 0 ? total_cnt:0}</b> 건)</Box>
        </Box>
        <Box display="flex" sx={{alignItems: "center", justifyContent: "right"}}>
          <Box sx={{marginLeft: "16px", fontSize:"16px"}}>작업상태</Box>
          <Select id="work_yn" value={work_yn} onChange={(e)=> { setWork_yn(e.target.value); swWikiWorkList(e.target.value); goPage(1);}} sx={{width:"128px",height: "30px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"모두"}>모두</MenuItem>
            <MenuItem dense value={"None"}>미작업</MenuItem>
            <MenuItem dense value={"Y"}>적합</MenuItem>
            <MenuItem dense value={"N"}>부적합</MenuItem>
          </Select>
        </Box>
      </Box>
      {/* 상단 메뉴 */}

      {/* Task 단위 화면 */}
      <TzaWikiListPage work_yn={work_yn} setPage={setPage} goPage={goPage} workList={workList} swWikiWorkList={swWikiWorkList}/>
      {/* Task 단위 화면 */}
    </Box>
  );
};

export default TzaWorkerWikiPage;
